/** Öğrenme ilerlemesi — yalnızca bu tarayıcıda, localStorage ile saklanır. */
import { WORDS } from '../data/words'

const KEY = 'dz-akrabalik-ogrenilen-v1'
const VALID = new Set(WORDS.map((w) => w.id))

export interface ProgressStore {
  has(id: string): boolean
  set(id: string, learned: boolean): void
  clear(): void
  count(): number
  /** Kayıt kalıcı mı (localStorage erişilebilir mi)? */
  persistent: boolean
}

function storageAvailable(): boolean {
  try {
    const t = '__dz_test__'
    localStorage.setItem(t, t)
    localStorage.removeItem(t)
    return true
  } catch {
    return false
  }
}

export function createProgressStore(): ProgressStore {
  const persistent = storageAvailable()
  const learned = new Set<string>()

  if (persistent) {
    try {
      const raw = localStorage.getItem(KEY)
      const parsed: unknown = raw ? JSON.parse(raw) : []
      if (Array.isArray(parsed)) {
        parsed.forEach((id) => typeof id === 'string' && VALID.has(id) && learned.add(id))
      }
    } catch {
      /* bozuk kayıt: yok say */
    }
  }

  const save = () => {
    if (!persistent) return
    try {
      localStorage.setItem(KEY, JSON.stringify([...learned]))
    } catch {
      /* kota dolu vb. — oturum içinde çalışmaya devam eder */
    }
  }

  return {
    persistent,
    has: (id) => learned.has(id),
    set(id, value) {
      if (!VALID.has(id)) return
      value ? learned.add(id) : learned.delete(id)
      save()
    },
    clear() {
      learned.clear()
      save()
    },
    count: () => learned.size
  }
}
